import React, { useEffect, useState } from "react";
import { InputLabel, makeStyles, MenuItem } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import {
  ORDER_STATUS_RECEIVED,
  ORDER_STATUS_RECEIVED_DRIVER,
} from "../../utils/constant";
import { connect } from "react-redux";
import {
  updateOrderStatus,
  updateOrderDriver,
} from "../../store/actions/admin/Admin";
import GridContainer from "../Grid/GridContainer";
import GridItem from "../Grid/GridItem";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import LocationOn from "@material-ui/icons/LocationOn";
import { CalendarToday, MonetizationOn, Money } from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    minHeight: "200px",
    backgroundColor: "white",
    borderRadius: "10px",
    margin: "0 auto",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    transition: "0.3s",
    marginTop: "10px",
    padding: "0px 10px",
  },
  reOrderBox: {
    width: "250px",
    padding: "10px",
    background: "#000000",
    color: "#ffffff",
    textAlign: "center",
    boxSizing: "border-box",
  },
  lightGreyText: {
    color: "grey",
    margin: "8px 0",
    fontSize: "15px",
  },
  boldText: {
    fontWeight: 600,
    fontSize: "20px",
    paddingTop: "5px",
    paddingLeft: "5px",
    paddingRight: "20px",
    textAlign: "left",
  },
  dotted: {
    fontSize: "14px",
    fontWeight: 600,
    width: "10px",
  },
  viewReceipt: {
    textDecoration: "underline",
    color: "black",
    fontSize: "15px",
    fontWeight: 500,
  },
  mediumtext: {
    fontSize: "14px",
    color: "black",
    textAlign: "left",
  },
  boxWrapper: {
    display: "flex",
    alignItems: "flex-start",
    margin: "16px 0",
    paddingLeft: "5px",
    justifyContent: "left",
  },
  numberText: {
    padding: "8px",
    border: "1px solid #fff",
    margin: "5px 0px 5px 0px",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 180,
  },
  imgContainer: {
    position: "relative",
    marginTop: "10px",
    backgroundSize: "100% 100%",
    height: "250px",
    width: "100%",
    backgroundRepeat: "no-repeat",
  },
  cardGradient: {
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    backgroundImage: "linear-gradient(to top,black,transparent)",
    color: "#fff",
    borderRadius: 10,
  },
  text14L: {
    fontSize: "14px",
    color: "grey",
    textAlign: "left",
    color: "#fff",
  },
  m0: {
    margin: 0,
  },
  itemListContainer: {
    display: "flex",
    overflow: "auto",
  },
  itemListInnerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "nowrap",
  },
  itemListSubItem: {
    width: "200px",
    backgroundColor: "#A7D6D7",
    marginRight: "2px",
    borderRadius: 5,
  },
}));

const OrderItemCard = ({
  id,
  isAdmin,
  image,
  isDriver,
  vendor,
  items,
  price,
  date,
  status,
  updateOrderStatus,
  updateOrderDeliveryBoy,
  address,
  order,
  user,
  drivers,
  orderRef,
  driver,
}) => {
  const classes = useStyles();
  const [orderStatus, updateStatus] = useState(1);
  const [orderDriver, updateOrderDriver] = useState(driver ? driver : "");
  const [open, setOpen] = React.useState(false);
  const [variant, setVariant] = React.useState([]);
  const handleClickOpen = (variant) => {
    setVariant(variant);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    const tempStatus = ORDER_STATUS_RECEIVED?.find((item) => {
      return item.value === status;
    });
    if (tempStatus) {
      updateStatus(tempStatus?.key);
    }
  }, []);
  useEffect(() => {
    const tempStatus = ORDER_STATUS_RECEIVED?.find((item) => {
      return item.value === status;
    });
    if (tempStatus) {
      updateStatus(tempStatus?.key);
    }
  }, [status]);

  useEffect(() => {
    updateOrderDriver(driver);
  }, [driver]);

  const handleChangeOrderStatus = (e) => {
    updateOrderStatus({
      orderId: id,
      requestType: e?.target?.value?.toString(),
    }).then((data) => {
      if (data) {
        updateStatus(e.target.value);
      }
    });
  };

  const handleChangeDriver = (e) => {
    updateOrderDeliveryBoy({
      orderId: id,
      driver: e?.target?.value?.toString(),
    }).then((data) => {
      if (data) {
        updateOrderDriver(e.target.value);
      }
    });
  };
  var isPickAndDrop = false;
  if (order && order.orderType == "PicknDrop") {
    isPickAndDrop = true;
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <div className={classes.wrapper}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <div
                className={classes.imgContainer}
                style={{
                  backgroundImage:
                    "url('" + (isPickAndDrop ? order.attachment : image) + "')",
                }}
              >
                <div className={classes.cardGradient}>
                  <div
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      padding: 10,
                    }}
                  >
                    {isPickAndDrop ? (
                      <div className={classes.boldText}>Pick And Drop</div>
                    ) : (
                      <>
                        <div className={classes.boldText}> {vendor?.name}</div>
                        <div className={classes.text14L}>
                          <LocationOn style={{ fontSize: "16px" }} />{" "}
                          {vendor?.address?.building_number}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={8}>
              <GridContainer style={{ padding: 10 }}>
                <GridItem xs={12} sm={12} md={6}>
                  {(isAdmin || isDriver) && (
                    <>
                      <div
                        className={classes.boxWrapper}
                        style={{ margin: "5px 0" }}
                      >
                        <div
                          className={`${classes.lightGreyText} ${classes.m0}`}
                        >
                          Name : {user.firstName} {user.lastName}
                        </div>
                      </div>
                      <div
                        className={classes.boxWrapper}
                        style={{ margin: "5px 0" }}
                      >
                        <div
                          className={`${classes.lightGreyText}  ${classes.m0}`}
                        >
                          Phone : {user.phone_number}
                        </div>
                      </div>
                    </>
                  )}
                  {!isPickAndDrop && (
                    <>
                      <div
                        className={classes.boxWrapper}
                        style={{ margin: "5px 0" }}
                      >
                        <div
                          className={`${classes.lightGreyText}  ${classes.m0}`}
                        >
                          Address:&nbsp;
                        </div>
                        <div className={classes.mediumtext}>
                          {address?.street}
                        </div>
                      </div>

                      <div
                        className={classes.boxWrapper}
                        style={{ margin: "5px 0" }}
                      >
                        <div
                          className={`${classes.lightGreyText} ${classes.m0}`}
                        >
                          Phone :&nbsp;
                        </div>
                        <div className={classes.mediumtext}>
                          {address?.phone_number}
                        </div>
                      </div>
                    </>
                  )}

                  <div
                    className={classes.boxWrapper}
                    style={{ margin: "5px 0" }}
                  >
                    <div
                      className={`${classes.lightGreyText} `}
                      style={{ margin: 0 }}
                    >
                      {items?.length} items for{" "}
                      <MonetizationOn
                        style={{ fontSize: "16px", margin: "2px 5px" }}
                      />{" "}
                      AUD.{price}
                      <div className={classes.dotted}>{""}</div>
                      <div>.</div>
                    </div>
                  </div>

                  {isPickAndDrop && (
                    <div>
                      <div
                        className={classes.boxWrapper}
                        style={{ margin: "5px 0" }}
                      >
                        <div
                          className={`${classes.lightGreyText}  ${classes.m0}`}
                        >
                          Distance:&nbsp;
                        </div>
                        <div className={classes.mediumtext}>
                          {order?.distance}
                        </div>
                      </div>
                      <div
                        className={classes.boxWrapper}
                        style={{ margin: "5px 0" }}
                      >
                        <div
                          className={`${classes.lightGreyText}  ${classes.m0}`}
                        >
                          No Of Packages:&nbsp;
                        </div>
                        <div className={classes.mediumtext}>
                          {order?.noOfPackages}
                        </div>
                      </div>
                      <div
                        className={classes.boxWrapper}
                        style={{ margin: "5px 0" }}
                      >
                        <div
                          className={`${classes.lightGreyText} ${classes.m0}`}
                        >
                          Note:&nbsp;
                        </div>
                        <div className={classes.mediumtext}>{order?.note}</div>
                      </div>
                      <div
                        className={classes.boxWrapper}
                        style={{ margin: "5px 0" }}
                      >
                        <div
                          className={`${classes.lightGreyText} ${classes.m0}`}
                        >
                          PickUp Name:&nbsp;
                        </div>
                        <div className={classes.mediumtext}>
                          {order?.pickUpAddress?.name}
                        </div>
                      </div>
                      <div
                        className={classes.boxWrapper}
                        style={{ margin: "5px 0" }}
                      >
                        <div
                          className={`${classes.lightGreyText} ${classes.m0} `}
                        >
                          PickUp Phone Number:&nbsp;
                        </div>
                        <div className={classes.mediumtext}>
                          {order?.pickUpAddress?.phone_number}
                        </div>
                      </div>
                      <div
                        className={classes.boxWrapper}
                        style={{ margin: "5px 0" }}
                      >
                        <div
                          className={`${classes.lightGreyText} ${classes.m0}`}
                        >
                          Pickup Building Number:&nbsp;
                        </div>
                        <div className={classes.mediumtext}>
                          {order?.pickUpAddress?.building_number}
                        </div>
                      </div>
                      <div
                        className={classes.boxWrapper}
                        style={{ margin: "5px 0" }}
                      >
                        <div
                          className={`${classes.lightGreyText} ${classes.m0}`}
                        >
                          PickUp Address:&nbsp;
                        </div>
                        <div className={classes.mediumtext}>
                          {order?.pickUpAddress?.street}
                        </div>
                      </div>
                      <div
                        className={classes.boxWrapper}
                        style={{ margin: "5px 0" }}
                      >
                        <div
                          className={`${classes.lightGreyText} ${classes.m0}`}
                        >
                          Drop Name:&nbsp;
                        </div>
                        <div className={classes.mediumtext}>
                          {order?.dropAddress?.name}
                        </div>
                      </div>
                      <div
                        className={classes.boxWrapper}
                        style={{ margin: "5px 0" }}
                      >
                        <div
                          className={`${classes.lightGreyText} ${classes.m0}`}
                        >
                          Drop Phone Number:&nbsp;
                        </div>
                        <div className={classes.mediumtext}>
                          {order?.dropAddress?.phone_number}
                        </div>
                      </div>
                      <div
                        className={classes.boxWrapper}
                        style={{ margin: "5px 0" }}
                      >
                        <div
                          className={`${classes.lightGreyText} ${classes.m0}`}
                        >
                          Drop Building Number:&nbsp;
                        </div>
                        <div className={classes.mediumtext}>
                          {order?.dropAddress?.building_number}
                        </div>
                      </div>
                      <div
                        className={classes.boxWrapper}
                        style={{ margin: "5px 0" }}
                      >
                        <div
                          className={`${classes.lightGreyText} ${classes.m0}`}
                        >
                          Drop Address:&nbsp;
                        </div>
                        <div className={classes.mediumtext}>
                          {order?.dropAddress?.street}
                        </div>
                      </div>
                    </div>
                  )}
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classes.lightGreyText}`}
                    style={{ textAlign: "left" }}
                  >
                    {orderRef ? (
                      <>
                        {" "}
                        <b>Order Ref No :</b> {orderRef}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    className={`${classes.lightGreyText}`}
                    style={{ textAlign: "left" }}
                  >
                    <CalendarToday style={{ fontSize: 14 }} /> Placed on{" "}
                    {new Date(date)?.toLocaleString()}
                  </div>

                  <div
                    className={`${classes.lightGreyText}`}
                    style={{ textAlign: "left" }}
                  >
                    <b>Driver Status : </b>
                    <span
                      style={{
                        color:
                          order?.driverStatus === "Accepted"
                            ? "green"
                            : order?.driverStatus === "Rejected"
                            ? "red"
                            : "white",
                      }}
                    >
                      <b>{order?.driverStatus}</b>
                    </span>
                  </div>

                  {!isAdmin && !isDriver && (
                    <GridItem
                      xs={12}
                      sm={12}
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <div className={classes.reOrderBox}>{status}</div>
                    </GridItem>
                  )}

                  <>
                    {(isAdmin || isDriver) && (
                      <>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={4}>
                            <div
                              className={`${classes.lightGreyText}`}
                              style={{ textAlign: "left" }}
                            >
                              {" "}
                              Delivery Boy
                            </div>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={8}>
                            <FormControl className={classes.formControl}>
                              <Select
                                disabled={
                                  isDriver ||
                                  orderStatus === 5 ||
                                  orderStatus === 4
                                }
                                labelId="demo-controlled-open-select-label"
                                id="demo-controlled-open-select"
                                value={orderDriver}
                                onChange={handleChangeDriver}
                                style={{ fontSize: 14 }}
                              >
                                {drivers?.map((item) => (
                                  <MenuItem
                                    style={{ fontSize: 14 }}
                                    selected={item.id === driver}
                                    value={item?.id}
                                  >
                                    {item?.username}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={4}>
                            <div
                              className={`${classes.lightGreyText}`}
                              style={{ textAlign: "left" }}
                            >
                              {" "}
                              Status
                            </div>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={8}>
                            <FormControl className={classes.formControl}>
                              <Select
                                labelId="demo-controlled-open-select-label"
                                id="demo-controlled-open-select"
                                value={orderStatus}
                                onChange={handleChangeOrderStatus}
                                style={{ fontSize: 14 }}
                              >
                                {isAdmin &&
                                  ORDER_STATUS_RECEIVED?.map((item) => (
                                    <MenuItem
                                      style={{ fontSize: 14 }}
                                      selected={item.value === status}
                                      value={item?.key}
                                    >
                                      {item?.value}
                                    </MenuItem>
                                  ))}
                                {isDriver &&
                                  ORDER_STATUS_RECEIVED_DRIVER?.map((item) => (
                                    <MenuItem
                                      selected={item.value === status}
                                      value={item?.key}
                                    >
                                      {item?.value}
                                    </MenuItem>
                                  ))}
                              </Select>
                            </FormControl>
                          </GridItem>
                        </GridContainer>
                      </>
                    )}
                  </>
                </GridItem>
                <GridItem
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ marginTop: "-20px" }}
                >
                  <div className={`${classes.itemListContainer}`}>
                    <div className={`${classes.itemListInnerContainer}`}>
                      {items?.map(
                        (item) =>
                          item?.products?.length > 0 && (
                            <div
                              className={`${classes.boxWrapper} ${classes.itemListSubItem}`}
                            >
                              <div className={classes.numberText}>
                                {item?.quantity}
                              </div>
                              <div
                                style={{
                                  padding: 4,
                                  fontSize: "12px",
                                  textAlign: "left",
                                }}
                              >
                                {item?.products[0]?.name || item?.menu[0]?.name}
                                &nbsp;&nbsp;
                                {item.variant && (
                                  <sub
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      handleClickOpen(item.variant)
                                    }
                                  >
                                    Customized
                                  </sub>
                                )}
                              </div>
                            </div>
                          )
                      )}
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
        </div>
      </GridItem>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <MuiDialogTitle>
          <Typography gutterBottom>
            <b>Add Ons</b>
          </Typography>
        </MuiDialogTitle>
        <MuiDialogContent>
          {variant &&
            variant.map((v) => {
              return (
                <>
                  <Typography gutterBottom>
                    <span>
                      <b>{v.name}</b>
                    </span>
                    &nbsp;&nbsp;&nbsp;
                    <span style={{ float: "right" }}>{v.price + " AUD"}</span>
                  </Typography>
                </>
              );
            })}
        </MuiDialogContent>
        <MuiDialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Close
          </Button>
        </MuiDialogActions>
      </Dialog>
    </GridContainer>
  );
};

const mapDispatchWithProps = (dispatch) => {
  return {
    updateOrderStatus: (data) => dispatch(updateOrderStatus(data)),
    updateOrderDeliveryBoy: (data) => dispatch(updateOrderDriver(data)),
  };
};

export default connect(null, mapDispatchWithProps)(OrderItemCard);
